import * as signalR from '@microsoft/signalr'
import store from './store'

var signalr = null

export default {
    init,
    start,
    on,
    onreconnected,
    invoke,
    stop
}
function init (userId) {
    signalr = new signalR.HubConnectionBuilder()
    .withAutomaticReconnect()
    .withUrl(process.env.VUE_SIGNALR_URL + '/message?userName=' + userId, {})
    .build()
}
function start () {
    signalr.start().then(() => {
        console.log('conneted')
        })
}
function stop () {
    signalr.stop().then(() => {
        console.log('disconneted')
        })
}
function on (fcName) {
    signalr.off(fcName, res => {
        console.log(res)
      })
    signalr.on(fcName, res =>{
        console.log(res)
        store.commit('setNotify', JSON.stringify(res))
      })
}
function onreconnected () {
    signalr.onreconnected((connectionId) => {
        console.log(connectionId);
      })
}
function invoke (api, userName, title, message) {
    signalr.invoke(api,
        userName,title,message
      )
}